<!--begin::QR Code-->
<span class="mdi mdi-qrcode wallet-card-icon" (click)="openQrcode()"></span>
<!--end::QR Code-->


<!--begin::QR Code Modal-->
<ng-template #qrcodeModal let-c="close" let-d="dismiss">
  <div class="qrcode-popup">
    <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="qr-container mat-card">
      <!--<div class="heading">{{'MEMBER.DASHBOARD.QR_CODE' | translate}}</div>-->
      <div class="qrcode">
        <qrcode [qrdata]="myAngularxQrCode" [size]="350" [level]="'L'"></qrcode>
      </div>
    </div>
    <div class="qr-text">
      <p class="qr-code-text" [innerHTML]="'QR Code' | content_translate: 'content'"></p>
    </div>
  </div>
</ng-template>
<!--end::QR Code Modal-->
